import { useQuery, useQueryClient } from "react-query";
import axios from "axios";

export const useSectionsData = (onSuccess, onError, token, locationId, isBigEvent) => {
    const fetchSections = () => {
        const headers = {
            Accept: "*/*",
            token: token,
        };

        return axios.get(
            `${process.env.REACT_APP_BASE_URL}:${process.env.REACT_APP_ADMIN_PORT}/sections/get_location_sections/${locationId}?isBigEvent=${isBigEvent}`,
            {
                headers,
            },
        );
    };

    return useQuery("sections-get", fetchSections, {
        retry: 1,
        refetchOnWindowFocus: false,
        enabled: true,
        onSuccess: onSuccess("sections"),
        onError: onError("sections"),
        select: (data) => data.data,
    });
};

export const useSectionData = (onSuccess, onError, token, sectionId, isBigEvent) => {
    const queryClient = useQueryClient();

    const fetchSection = () => {
        const headers = {
            Accept: "*/*",
            token: token,
        };

        console.log("fetching");

        return axios.get(
            `${process.env.REACT_APP_BASE_URL}:${process.env.REACT_APP_ADMIN_PORT}/sections/get_section/${sectionId}?isBigEvent=${isBigEvent}`,
            {
                headers,
            },
        );
    };

    return useQuery({
        refetchOnWindowFocus: false,
        queryKey: ["sections-get", sectionId],
        queryFn: () => fetchSection(),
        select: (data) => data.data,
        initialData: () => {
            const data = queryClient.getQueryData(["sections-get"])?.data;
            return data
                ? { data: data.find((section) => section.sectionId === sectionId) }
                : undefined;
        },
    });
};

export const useSectionFile = (onSuccess, onError, token, fileName) => {
    const fetchFile = () => {
        const headers = {
            Accept: "*/*",
            token: token,
        };

        return axios.get(
            `${process.env.REACT_APP_BASE_URL}:${process.env.REACT_APP_ADMIN_PORT}/sections/file/${fileName}`,
            {
                responseType: "arraybuffer",
                headers,
            },
        );
    };

    return useQuery(["sections-get", fileName], fetchFile, {
        retry: 1,
        refetchOnWindowFocus: false,
        enabled: true,
        onSuccess: onSuccess("files"),
        onError: onError("files"),
        select: (data) => {
            return data.data;
        },
    });
};
